import { FC } from "react";
import { MetricWidgetBase } from "@app/network-portfolio-management/components/widgets/MetricWidgetBase";
import { useGetGapsCount } from "@app/network-portfolio-management/services/npmQueries";

interface Props {
  projectIds: number[] | undefined;
}

export const GapsWidget: FC<Props> = ({ projectIds }) => {
  const { data, isLoading, isSuccess, error } = useGetGapsCount(projectIds);

  return (
    <MetricWidgetBase
      title="Gap Count"
      isLoading={isLoading}
      error={!!error}
    >
      <div>
        {isSuccess && (
          <p className="main-metric">{data.totalGapCount.toLocaleString()}</p>
        )}
      </div>
    </MetricWidgetBase>
  );
};
